import { Scenario } from './page-data';

export function getImageUrlFromScenario(
  scenario: Scenario | undefined
): string | undefined {
  if (
    scenario &&
    scenario.metadata &&
    scenario.metadata.patient &&
    scenario.metadata.patient.name
  ) {
    const name = scenario.metadata.patient.name.toLowerCase();
    // Using absolute path for images
    const pictureUrl = `https://app.its-bhss.org/assets/its/image/${name}.jpg`;

    return pictureUrl;
  } else {
    return undefined;
  }
}

export function stripHtml(html: string): string {
  // Create a new div element
  const temporalDivElement = document.createElement('div');
  // Set the HTML content with the providen
  temporalDivElement.innerHTML = html;
  // Retrieve the text property of the element (cross-browser support)
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
}

export function combineClassNames(...classNames: (string | undefined)[]) {
  return classNames.join(' ');
}
